<div class="app-container">
  @if (showHeaderFooter) {
    <app-header></app-header>
  }

  <app-cookie-banner></app-cookie-banner>

  <main class="main-content">
    <router-outlet (activate)="onActivate()"></router-outlet>
  </main>

  @if (showHeaderFooter) {
    <app-footer></app-footer>
  }
</div>
